module.exports = __webpack_public_path__ + "static/media/W.98ff716e.svg";